import React, { useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { getNavItemsForUser } from "./navConfig";
import { FiUsers, FiBriefcase, FiDollarSign, FiFileText, FiUserCheck, FiCodesandbox, FiPackage, FiMapPin } from "react-icons/fi";
import "./BottomNav.css";

const BottomNav = ({ currentUser, todoTaskCount = 0 }) => {
  const navItems = getNavItemsForUser(currentUser);
  const [showMenu, setShowMenu] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Define secondary navigation items for pages that have them
  const secondaryNavConfig = {
    "/outreach": [
      { name: "People", path: "/outreach/people", icon: <FiUsers /> },
      { name: "Companies", path: "/outreach/companies", icon: <FiBriefcase /> },
      { name: "Sales", path: "/outreach/sales", icon: <FiDollarSign /> },
      { name: "States", path: "/outreach/states", icon: <FiMapPin /> },
      { name: "Email Templates", path: "/outreach/email-templates", icon: <FiFileText /> }
    ],
    "/partners": [
      { name: "Partners", path: "/partners/manager", icon: <FiUserCheck /> },
      { name: "QR Generator", path: "/partners/qr-generator", icon: <FiCodesandbox /> },
      { name: "ONEbox Manager", path: "/partners/onebox-manager", icon: <FiPackage /> }
    ]
  };

  const handleNavClick = (e, item) => {
    const hasSecondaryNav = secondaryNavConfig[item.path];
    
    if (hasSecondaryNav) {
      e.preventDefault();
      setShowMenu(showMenu === item.path ? null : item.path);
    } else {
      setShowMenu(null);
    }
  };

  const handleMenuItemClick = (path) => {
    navigate(path);
    setShowMenu(null);
  };

  const isActive = (item) => {
    return location.pathname.startsWith(item.path);
  };

  return (
    <>
      {showMenu && (
        <div className="bottom-nav-overlay" onClick={() => setShowMenu(null)} />
      )}
      <nav className="bottom-nav">
        {navItems.map((item) => {
          const hasSecondaryNav = secondaryNavConfig[item.path];
          const secondaryItems = secondaryNavConfig[item.path];
          
          return (
            <div key={item.name} className="bottom-nav-item-wrapper">
              {showMenu === item.path && secondaryItems && (
                <div className="bottom-nav-menu">
                  {secondaryItems.map((subItem) => (
                    <button
                      key={subItem.name}
                      className={`bottom-nav-menu-item ${location.pathname === subItem.path ? 'active' : ''}`}
                      onClick={() => handleMenuItemClick(subItem.path)}
                    >
                      {subItem.icon}
                      <span>{subItem.name}</span>
                    </button>
                  ))}
                </div>
              )}
              
              {hasSecondaryNav ? (
                <button
                  className={`nav-link ${isActive(item) ? 'active' : ''}`}
                  onClick={(e) => handleNavClick(e, item)}
                >
                  <div className="bottom-nav-icon-wrapper">
                    {item.icon}
                    {item.path === "/todo" && todoTaskCount > 0 && (
                      <span className="bottom-nav-badge">{todoTaskCount > 99 ? '99+' : todoTaskCount}</span>
                    )}
                  </div>
                  <span>{item.name}</span>
                </button>
              ) : (
                <NavLink
                  to={item.path}
                  className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                  onClick={() => setShowMenu(null)}
                >
                  <div className="bottom-nav-icon-wrapper">
                    {item.icon}
                    {item.path === "/todo" && todoTaskCount > 0 && (
                      <span className="bottom-nav-badge">{todoTaskCount > 99 ? '99+' : todoTaskCount}</span>
                    )}
                  </div>
                  <span>{item.name}</span>
                </NavLink>
              )}
            </div>
          );
        })}
      </nav>
    </>
  );
};

export default BottomNav;


